import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { DensityHistogramPlotLabels } from '@digital-twins/deck-ui/plots/density-histogram'

export interface DensityHistogramChrome {
  labels: DensityHistogramPlotLabels
  /** BCP-47 tag the plot formats numbers and currency with. */
  locale: string
}

/**
 * The `density-histogram` chrome in the viewer's UI language (plots plan M,
 * owner decision 5), keyed by the plot's label keys, so quick study and the
 * survey tab print the same words `deck_labels.py` gives the deck. Templates
 * keep single-brace placeholders (`{low}`), which the plot fills.
 */
export function useDensityHistogramLabels(): DensityHistogramChrome {
  const { t, i18n } = useTranslation('app')

  return useMemo(
    () => ({
      labels: {
        median: t('studyReport.densityHistogram.median'),
        mean: t('studyReport.densityHistogram.mean'),
        continuous_density_y_axis_title: t('studyReport.densityHistogram.yAxisTitle'),
        continuous_density_x_axis_title_fallback: t('studyReport.densityHistogram.xAxisTitleFallback'),
        continuous_density_iqr_band_legend: t('studyReport.densityHistogram.bandLegend'),
        plot_bin_range: t('studyReport.densityHistogram.binRange'),
        plot_bin_half_open: t('studyReport.densityHistogram.binHalfOpen'),
        plot_bin_open_top: t('studyReport.densityHistogram.binOpenTop'),
        plot_bin_open_bottom: t('studyReport.densityHistogram.binOpenBottom'),
        plot_low_base: t('studyReport.densityHistogram.lowBase'),
        plot_base_n: t('studyReport.densityHistogram.baseN'),
      },
      locale: i18n.language || 'en',
    }),
    [t, i18n.language],
  )
}
